import { render, staticRenderFns } from "./editSend.vue?vue&type=template&id=bba82a30&scoped=true&"
import script from "./editSend.vue?vue&type=script&lang=js&"
export * from "./editSend.vue?vue&type=script&lang=js&"
import style0 from "./editSend.vue?vue&type=style&index=0&id=bba82a30&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba82a30",
  null
  
)

export default component.exports